import type {
  NotificationInboxMessage,
  OpenableNotificationInboxMessage,
} from './notificationInboxMessages';

export const MOCK_INBOX_STORAGE_KEY = 'customerio_inbox_mock';

export type NotificationInboxEntry = NotificationInboxMessage &
  OpenableNotificationInboxMessage & { trackClick: () => void };

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export const createMockInboxMessages = (
  now: Date,
): NotificationInboxEntry[] => {
  const entry = (
    messageId: string,
    ageMs: number,
    opened: boolean,
    type: string,
    properties: Record<string, unknown>,
  ): NotificationInboxEntry => ({
    messageId,
    opened,
    sentAt: new Date(now.getTime() - ageMs),
    type,
    properties,
    markOpened: () => Promise.resolve(),
    trackClick: () => undefined,
  });

  return [
    entry('mock-mls', 10 * MINUTE, false, 'mls_new_listing', {
      lot_id: 'mock-lot-id',
      notification_title: 'New listing on the MLS',
      notification_body: '4.5 rooms · Lausanne',
    }),
    entry('mock-share-request', 30 * MINUTE, false, 'mls_share_request', {
      mls_share_id: 'mock-share-id',
      lot_id: 'mock-lot-id',
      listing_title: 'Villa with lake view',
      requester_name: 'Marc Dupont',
      team_name: 'Lake Realty',
    }),
    entry('mock-share-accepted', 45 * MINUTE, false, 'mls_share_accepted', {
      mls_share_id: 'mock-share-id',
      lot_id: 'mock-lot-id',
      listing_title: 'Villa with lake view',
      owner_name: 'Sophie Martin',
    }),
    entry('mock-share-declined', 1 * HOUR, true, 'mls_share_declined', {
      mls_share_id: 'mock-share-id',
      lot_id: 'mock-lot-id',
      listing_title: 'Villa with lake view',
      owner_name: 'Sophie Martin',
    }),
    entry('mock-revaluation', 90 * MINUTE, false, 'property_revaluation', {
      lead_id: 'mock-lead-id',
      contact: 'John Smith',
      property_address: 'Rue du Lac 12, Lausanne',
    }),
    entry('mock-map-leads', 3 * HOUR, false, 'prospection_map_new_leads', {
      count: '4',
    }),
    entry('mock-lead', 2 * HOUR, false, 'new_lead', {
      lead_id: 'mock-lead-id',
      source: 'result_page',
    }),
    entry('mock-enquiry', 5 * HOUR, false, 'new_enquiry', {
      enquiry_id: 'mock-enquiry-id',
      contact: 'Jane Doe',
    }),
    entry('mock-tasks', 26 * HOUR, false, 'daily_tasks_summary', {
      today: 3,
      overdue: 2,
    }),
    entry('mock-review', 30 * HOUR, true, 'new_review', {
      review_id: 'mock-review-id',
      reviewer_email: 'client@example.com',
      relationship: 'Seller',
    }),
    entry('mock-transaction', 5 * DAY, true, 'daily_transaction_reminder', {
      monthsSince: 3,
    }),
  ];
};
